/*
 * KAS LUXURY — scroll reveal.
 *
 * Settles the homepage's own blocks into place as they come into view. One
 * direction, one distance, a long ease. What reads as expensive on the reference
 * sites is the SLOWNESS, not the distance travelled.
 *
 * THE SAFETY RULE THIS IS BUILT AROUND
 * Hiding content with CSS and revealing it with JavaScript means that if the
 * JavaScript does not run, the content never comes back. So nothing is hidden by
 * the stylesheet on its own: the hidden state is scoped to html.kas-motion, and
 * this file adds that class only at the moment it is about to start observing.
 * No script, no class, no hiding -- the page just renders.
 *
 * On top of that there is a 2.5 second backstop that reveals anything still
 * hidden, which covers a throttled background tab or an observer that silently
 * never fires.
 */
(function () {
  'use strict';

  var TARGETS = [
    '.kas-dark-home__hero-copy',
    '.kas-dark-category',
    '.kas-dark-feature__media',
    '.kas-dark-feature__copy',
    '.kas-dark-products__head',
    '.kas-dark-products__grid > *',
    '.kas-dark-editorial__copy',
    '.kas-dark-editorial__media',
    '.kas-dark-trust > div',
    '.kas-dark-heritage__media',
    '.kas-dark-heritage__copy'
  ];

  var BACKSTOP_MS = 2500;

  function reducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function start() {
    if (reducedMotion() || typeof IntersectionObserver === 'undefined') {
      return;
    }

    var els = [];
    TARGETS.forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
        if (els.indexOf(el) === -1) {
          els.push(el);
        }
      });
    });
    if (!els.length) {
      return;
    }

    function show(el) {
      el.classList.add('kas-reveal-in');
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }
        var el = entry.target;
        // a small stagger across siblings, capped so a long grid never crawls
        var idx = el.parentElement
          ? Array.prototype.indexOf.call(el.parentElement.children, el)
          : 0;
        el.style.transitionDelay = Math.min(idx, 5) * 90 + 'ms';
        show(el);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    // Only now is it safe to let the stylesheet hide anything.
    document.documentElement.classList.add('kas-motion');

    els.forEach(function (el) {
      el.classList.add('kas-reveal');
      io.observe(el);
    });

    // Backstop: whatever has not revealed itself by now is shown regardless.
    window.setTimeout(function () {
      els.forEach(function (el) {
        if (!el.classList.contains('kas-reveal-in')) {
          el.style.transitionDelay = '0ms';
          show(el);
        }
      });
    }, BACKSTOP_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());